import React from 'react';

import './WorkflowDataSelector.scss';


const WorkflowDataSelector = (
    {
        data,
        onDataSelected,
        elementContainerClass,
        searchString,
        labelStyle,
        containerClassName,
        saveIntegrationData,
    }:
        {
            data: any,
            onDataSelected: any,
            elementContainerClass?: any,
            searchString: any,
            labelStyle?: any,
            containerClassName?: any
            saveIntegrationData?: Function
        }
) => {

    const searchLower = (searchString && searchString.length > 1) ? searchString.toString().toLowerCase() : '';


    // Find all keys that match the search string and their related data
    const matchedKeys = data
        .filter(({ key }: any) => key.toString().toLowerCase().includes(searchLower))
        .map(({ key, data }: any) => ({ key, data }));

    // Find all data items that match the search string
    const matchedData = data
        .flatMap(({ key, data }: any) =>
            data.filter((item: any) => item.label.toString().toLowerCase().includes(searchLower))
                .map((item: any) => ({ key, data: [item] }))
        );

    // Combine matched keys with matched data
    const combinedResults = [
        ...matchedKeys,
        ...matchedData.filter(({ key, data }: any) =>
            !matchedKeys.some((matchedKey: any) => matchedKey.key === key)
        )
    ];

    // Remove duplicate entries (if any) based on key and data value
    // const uniqueResults = Array.from(new Map(combinedResults.map((item: any) => [item.key, item])).values());

    const uniqueResults = combinedResults.filter((item, index, self) =>
        index === self.findIndex(t => JSON.stringify(t) === JSON.stringify(item))
    );

    const groupedData = uniqueResults.reduce((acc, item) => {
        // Check if the key already exists in the accumulator
        if (!acc[item.key]) {
            // Initialize with an empty array if key is not present
            acc[item.key] = [];
        }
        // Push the item data into the array corresponding to the key
        acc[item.key].push(...item.data);
        return acc;
    }, {});

    const result = Object.keys(groupedData).map(key => ({
        key,
        data: groupedData[key]
    }));


    function transformData(result: { key: string; data: any[] }[]) {
        const integrationSubdata: { key: string; data: any[] }[] = [];
        const finalOutput: any[] = [];

        result.forEach(({ key, data }) => {
            const externalItems = data.filter(item => item.external === true);
            const nonExternalItems = data.filter(item => item.external !== true);

            if (externalItems.length > 0) {
                integrationSubdata.push({ key, data: externalItems });
            }

            if (nonExternalItems.length > 0) {
                finalOutput.push({ key, data: nonExternalItems });
            }
        });

        if (integrationSubdata.length > 0) {
            finalOutput.unshift({
                key: 'Integrations',
                subdata: integrationSubdata
            });
        }

        return finalOutput;
    }
    const transformed = result && transformData(result);
    const transformed2 = uniqueResults && transformData(uniqueResults);

    return (
        <div className={`workflow-data-selector-container ${containerClassName ? containerClassName : ''}`}>
            {
                searchLower.length > 0 ?
                    <>
                        {transformed.length > 0 ? (
                            transformed.map((section: any, index: number) => (
                                <div key={index}>
                                    {/* Handle the Integration section with nested subdata */}
                                    {section.subdata ? (
                                        <>
                                            {(section.key.toLowerCase().includes(searchLower) || section.subdata.some((sub: any) => sub.data.length > 0)) && (
                                                <p className="workflow-data-selector-categoryTitle">{section.key}</p>
                                            )}

                                            {section.subdata.map((subsection: any, subIndex: number) => (
                                                <div key={subIndex}>
                                                    {(subsection.key.toLowerCase().includes(searchLower) || subsection.data.length > 0) && (
                                                        <div
                                                            className='workflow-data-selector-icon'
                                                            onClick={() => {
                                                                if (saveIntegrationData) {
                                                                    saveIntegrationData(subsection.data)
                                                                }
                                                                
                                                                onDataSelected(subsection.key === 'kit' ? 'Kit (Convertkit)' : subsection.key, {
                                                                    ...subsection,
                                                                    external: true
                                                                })
                                                            }}
                                                        >
                                                            <p className="workflow-data-selector-IntegrationTitle workflow-data-selector-IntegrationTitle-search" >
                                                                {
                                                                    subsection.key === 'kit'
                                                                        ?
                                                                        'Kit (Convertkit)'
                                                                        :
                                                                        subsection.key
                                                                }
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        // Handle normal categories
                                        <>
                                            {(section.key.toLowerCase().includes(searchLower) || section.data.length > 0) && (
                                        <p className="workflow-data-selector-categoryTitle">
                                                    {section.key === 'landing-page'
                                                        ? 'Landing Pages'
                                                        : section.key === 'library-content'
                                                            ? 'Content Library'
                                                            : section.key === 'direct-message'
                                                                ? 'Direct Message'
                                                                : section.key}
                                        </p>
                                    )}

                                            {section.data.map((dataElement: any, idx: number) => (
                                        <div
                                            key={idx}
                                                    className={`workflow-data-selector-element-container${elementContainerClass ? ` ${elementContainerClass}` : ''} ${dataElement.unavailable ? 'unavailable' : ''
                                                        }`}
                                            onClick={() => onDataSelected(dataElement.value, dataElement)}
                                        >
                                            <p
                                                className={`workflow-data-selector-element-label ${dataElement.unavailable ? 'unavailable' : ''} ${labelStyle ? labelStyle : ''}`}
                                            >
                                                {dataElement.label}
                                            </p>
                                            {dataElement.subtext && (
                                                        <p className="workflow-data-selector-element-subtext">{dataElement.subtext}</p>
                                            )}
                                        </div>
                                    ))}
                                        </>
                                    )}
                                </div>
                            ))

                        ) : (
                            <h1 className='workflow-data-selector-no-results'>No results found</h1>
                        )}
                    </>
                    :
                    <>
                        {transformed2.length > 0 ? (
                            transformed2.map((section: any, index: number) => (
                                <div key={index}>
                                    {/* Handle the Integration section with nested subdata */}
                                    {section.subdata ? (
                                        <>
                                            {(section.key.toLowerCase().includes(searchLower) || section.subdata.some((sub: any) => sub.data.length > 0)) && (
                                                <p className="workflow-data-selector-categoryTitle">{section.key}</p>
                                            )}

                                            {section.subdata.map((subsection: any, subIndex: number) => (
                                                <div key={subIndex} className='workflow-data-selector-subdata'>
                                                    {(subsection.key.toLowerCase().includes(searchLower) || subsection.data.length > 0) && (

                                                        <p
                                                            onClick={() => {
                                                                if (saveIntegrationData) {
                                                                    saveIntegrationData(subsection.data)
                                                                }

                                                                onDataSelected(subsection.key === 'kit' ? 'Kit (Convertkit)' : subsection.key, {
                                                                    ...subsection,
                                                                    external: true
                                                                })
                                                            }}
                                                            className="workflow-data-selector-IntegrationTitle" >
                                                            {
                                                                subsection.key === 'kit'
                                                                    ?
                                                                    'Kit (Convertkit)'
                                                                    :
                                                                    subsection.key
                                                            }
                                                        </p>

                                                    )}
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        // Handle normal categories
                                        <>
                                            {(section.key.toLowerCase().includes(searchLower) || section.data.length > 0) && (
                                        <p className="workflow-data-selector-categoryTitle">
                                                    {section.key === 'landing-page'
                                                        ? 'Landing Pages'
                                                        : section.key === 'library-content'
                                                            ? 'Content Library'
                                                            : section.key === 'direct-message'
                                                                ? 'Direct Message'
                                                                : section.key}
                                        </p>
                                    )}

                                            {section.data.map((dataElement: any, idx: number) => (
                                        <div
                                            key={idx}
                                                    className={`workflow-data-selector-element-container${elementContainerClass ? ` ${elementContainerClass}` : ''} ${dataElement.unavailable ? 'unavailable' : ''
                                                        }`}
                                            onClick={() => onDataSelected(dataElement.value, dataElement)}
                                        >
                                            <p
                                                        className={`workflow-data-selector-element-label ${dataElement.unavailable ? 'unavailable' : ''} ${labelStyle ? labelStyle : ''
                                                            }`}
                                            >
                                                {dataElement.label}
                                            </p>
                                            {dataElement.subtext && (
                                                        <p className="workflow-data-selector-element-subtext">{dataElement.subtext}</p>
                                            )}
                                        </div>
                                    ))}
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <h1 className='workflow-data-selector-no-results'>No results found</h1>
                        )}

                    </>
            }
        </div>
    );
};

export default WorkflowDataSelector